<template>
  <el-dialog
    :visible="true"
    :fullscreen="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
    class="popupContainer"
    title="关于我们"
    :center="true"
  >
    <div
      class="main-container as-full-width as-full-height as-flex flex-vertical main-center cross-center"
    >
      <img class="img" src="../../assets/images/login-logo.png">
      <span class="f-2 fc-gray-2">凡影旗下敏捷调研数据平台</span>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "guide",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleClose(done) {
      this.closePopup();
    },
    closePopup() {
      this.$emit("closeModal");
    }
  },
  watch: {},
  created() {}
};
</script>

<style lang="scss" scoped>
.popupContainer {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 420px;
  height: 500px;
  border-radius: 20px;
  // padding: 20px;
}
.main-container {
  height: 300px;
}
.img {
  width: 120px;
  margin-bottom: 20px;
}
</style>